module.exports = __webpack_public_path__ + "img/sonacos copy.7b28cda8.jpg";